import React from "react";
import Select from "react-select";

const MAX_MENU_HEIGHT = 240;
const SEARCHABLE_OPTION_THRESHOLD = 6;

function SelectV2({
    inputId,
    className = "",
    value,
    onChange,
    options = [],
    isSearchable,
    isClearable = false,
    isDisabled = false,
    placeholder = "",
    noOptionsMessage,
    menuPlacement = "auto",
    maxMenuHeight = MAX_MENU_HEIGHT
}) {
    const menuPortalTarget = typeof document !== "undefined" ? document.body : null;
    const selectedOption = options.find((option) => String(option.value) === String(value)) || null;
    const searchable = isSearchable ?? options.length > SEARCHABLE_OPTION_THRESHOLD;
    const wrapperClassName = `oct_selectsearch-v2 ${className}`
        .split(/\s+/)
        .filter((token) => token && token !== "oct_select-v2" && token !== "oct_select" && token !== "form-control")
        .join(" ");

    return (
        <Select
            inputId={inputId}
            instanceId={inputId}
            className={wrapperClassName}
            classNamePrefix="oct-selectsearchsub-v2"
            value={selectedOption}
            onChange={(selectedOptionValue) => onChange(selectedOptionValue?.value ?? "")}
            options={options}
            isSearchable={searchable}
            isClearable={isClearable}
            isDisabled={isDisabled}
            menuPlacement={menuPlacement}
            menuPosition="fixed"
            maxMenuHeight={maxMenuHeight}
            minMenuHeight={maxMenuHeight}
            menuShouldScrollIntoView={false}
            menuPortalTarget={menuPortalTarget}
            placeholder={placeholder}
            noOptionsMessage={noOptionsMessage}
        />
    );
}

export default SelectV2;
